import * as Sentry from '@sentry/browser';
import * as SentryVue from '@sentry/vue';
import type { App } from 'vue';
import { SENTRY_APPLICATION_KEY } from './sentry_constants';

// Sentryの初期化状態を管理するフラグ
let isSentryInitialized: boolean = false;

export function initSentry(app?: App | App[]) {
  // 開発環境の場合はスキップ
  if(import.meta.env.DEV) return;

  // すでに初期化済みの場合はスキップ
  if(isSentryInitialized) return;

  // 初期化済みにマーク
  isSentryInitialized = true;

  /** Sentryのオプション */
  const options: Sentry.BrowserOptions = {
    dsn: import.meta.env.SENTRY_DSN,
    environment: import.meta.env.RAILS_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      // ビルド時にvite.config.tsのsentryVitePluginがバンドルへ埋め込んだ
      // applicationKeyを元に、自社バンドルのフレームを一切含まないエラー
      // （GTM/VWO等のサードパーティスクリプト由来と推定されるノイズ）に
      // third_party_code:true タグを付与する。
      // 段階導入のため現時点ではドロップはせず、タグ付けのみ行う。
      // 発生状況を確認できたら behaviour を drop-error-if-exclusively-... に切り替える。
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: [SENTRY_APPLICATION_KEY],
        behaviour: 'apply-tag-if-exclusively-contains-third-party-frames'
      })
    ],
    tracesSampleRate: 0.01,
    // 例：['agent.m3career.com'] とすると、agent.m3career.comを含むURLで発生したエラーのみをキャプチャする
    allowUrls: ['agent.m3career.com', 'googletagmanager.com']
  }

  if(app) {
    // Vue3 app指定の場合はVue用の初期化を行う
    // 配列の場合は複数のappを渡せる
    SentryVue.init({
      ...options,
      app,
      trackComponents: true
    });
  }
  else {
    // app未指定の場合はVanillaJS用の初期化を行う
    Sentry.init(options);
  }
}